import { DownCaratIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useCallback, useState } from 'react';
import { useOutOfOfficeHours } from '../../../working-hours/hooks/useOutOfOfficeHours';
import { useTrackAvailabilityClicked } from '../../hooks/useTrackAvailabilityClicked';
import { useCurrentUserCapacityLimits } from '../../hooks/useUserLevelCapacityLimits';
import { getStatusMessage } from '../../utils/agentStatusUtils';
import AvailabilityIndicator from '../AvailabilityIndicator';
import { AvailabilityPopover } from './AvailabilityPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AvailabilityButton = ({
  isAway,
  portalCapacityLimit,
  portalCapacityLoad,
  updateAwayMode,
  userId,
  workspace
}) => {
  const trackAvailabilityClicked = useTrackAvailabilityClicked();
  const [isOpen, setIsOpen] = useState(false);
  const {
    capacity,
    loading
  } = useCurrentUserCapacityLimits();
  const {
    currentSegment
  } = useOutOfOfficeHours(userId, {
    isViewingSelf: true
  });
  const onAwayModeToggle = useCallback(() => {
    updateAwayMode(!isAway);
    setIsOpen(false);
  }, [updateAwayMode, isAway]);
  const handleClick = useCallback(() => {
    trackAvailabilityClicked(isOpen);
    setIsOpen(prev => !prev);
  }, [trackAvailabilityClicked, isOpen]);
  const handleOpenChange = useCallback(e => setIsOpen(e.currentTarget.value), []);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingInlineStart: "250",
    children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
      atCapacity: false,
      isAwayMode: isAway
    }), /*#__PURE__*/_jsx(Popover, {
      inlineSize: "340px",
      placement: "top right",
      open: isOpen,
      onOpenChange: handleOpenChange,
      arrowSize: "none",
      content: /*#__PURE__*/_jsx(AvailabilityPopover, {
        capacity: capacity,
        currentSegment: currentSegment,
        isAway: isAway,
        onAwayModeToggle: onAwayModeToggle,
        portalCapacityLimit: portalCapacityLimit,
        portalCapacityLoad: portalCapacityLoad,
        workspace: workspace
      }),
      children: /*#__PURE__*/_jsxs(Button, {
        disabled: loading,
        use: "link",
        onClick: handleClick,
        "data-test-id": "availability-menu-button",
        children: [getStatusMessage(isAway), /*#__PURE__*/_jsx(DownCaratIcon, {})]
      })
    })]
  });
};
AvailabilityButton.displayName = 'AvailabilityButton';